import Config from "../../config/Config";
const axios = require("axios");
const BaseUrlPerizinanDev = `${Config.BaseUrlPerizinanDev}/user/boarding-leave-request`;
const BaseUrlPerizinanTypeDev = `${Config.BaseUrlPerizinanDev}/admin/boarding-leave-type`;

const bearer = () => {
  const token = localStorage.getItem("token_redux");
  return token ? token.replaceAll('"', "") : "";
};

export const getDashboardPerizinan = (params) => {
  return axios.get(`${BaseUrlPerizinanDev}/dashboard`, {
    params,
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getPerizinanAll = (params) => {
  return axios.get(BaseUrlPerizinanDev, {
    params,
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getPerizinanOut = (params) => {
  return axios.get(`${BaseUrlPerizinanDev}/student/out`, {
    params,
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const postPerizinan = (data) => {
  return axios.post(BaseUrlPerizinanDev, data, {
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getPerizinanDetail = (id) => {
  return axios.get(`${BaseUrlPerizinanDev}/${id}/detail`, {
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};

export const getPerizinanType = (params) => {
  return axios.get(BaseUrlPerizinanTypeDev, {
    params,
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};
